import { Inject, Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";
import { OktaAuth } from "@okta/okta-auth-js";
import { OKTA_AUTH } from "@okta/okta-angular";
import { HttpOktaService } from "@weps/shared-http";
import localSettings from "../mock-data/local-settings.json";

@Injectable()
export class HttpInterceptors implements HttpInterceptor {
  //Whitespace is intentional
  protected readonly XSRF_TOKEN = "XSRF-TOKEN";
  protected readonly X_XSRF_TOKEN = "X-XSRF-TOKEN";
  protected readonly ALLOW_ORIGIN_HEADER: string = "Access-Control-Allow-Origin";
  protected readonly AUTHORIZATION_HEADER: string = "Authorization";
  protected  readonly ORIGIN_HEADER: string = "Origin"
  protected readonly CONSUMER_HEADER: string = "Consumer-Application-Code";
  protected readonly CONSUMER_VALUE: string = "ROB";
  protected readonly BEARER_HEADER: string = "Bearer ";
  constructor(
    @Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private httpOktaService: HttpOktaService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let modifiedReq;

    const isLocal = environment.deployment === "local"
    const isGatekeeperUrl = request.url.includes("gatekeeper")

    if(isLocal && !isGatekeeperUrl) {
      const accessToken = localSettings.accessToken
      {
        modifiedReq = request.clone({
          headers: request.headers
            .set(this.AUTHORIZATION_HEADER, this.BEARER_HEADER + accessToken)
            .set(this.ALLOW_ORIGIN_HEADER, localSettings.localUrl)
        });
      }
      return next.handle(modifiedReq);
    }
    else {
      return next.handle(request);
    }

  }
}
